/**
 * "View bank transactions" glyph (axes + rising line) — the drill-down affordance
 * shown next to a LOC Usage figure on both the LOC Availability page and the Cash
 * Position Summary grid (DCP-169). A zero-dependency pure SVG; shared here so the
 * two call sites read identically instead of keeping byte-for-byte copies.
 *
 * @param className - forwarded to the `<svg>` for sizing/colour (currentColor).
 */
export function ViewTransactionsIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M3 3v18h18" />
      <path d="m7 14 4-4 3 3 5-6" />
    </svg>
  )
}
